// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"21ab7ba9","455":"666b0217"}[chunkId] + ".chunk.js";
};